import { collectErrorMessages, createAuthenticatedApiConfig } from "@/lib/utils.server";
import { createServerFn } from "@tanstack/react-start";
import { getEnumDefinitions } from "@/lib/mma";
import { queryOptions } from "@tanstack/react-query";

export const getEnumsFn = createServerFn({ method: "GET" }).handler(async () => {
  const config = await createAuthenticatedApiConfig();
  const response = await getEnumDefinitions({
    ...config,
  });
  if (!response.data) {
    throw new Error(collectErrorMessages(response.error) || "Failed to get enums");
  }
  return response.data.data;
});

export const getEnumDefinitionsQueryOptions = queryOptions({
  queryKey: ["enums"],
  queryFn: getEnumsFn,
  staleTime: 1000 * 60 * 60 * 24,
  gcTime: 1000 * 60 * 60 * 24,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
});
